import { S3Policy as S3PolicyType } from '@/client/types/aws/s3Policy';
import axios from 'axios';
import v3ApiService from '../clients/v3ApiClient';

// TODO: Replace all unique instances of uploads to S3 with this.
// TODO: Handle partner policy
const uploadToBucket = async (
  file: File,
  progressCallback?: (percentCompleted: number) => void,
): Promise<{ cloudFrontLink: string }> => {
  const { type, name } = file;

  // Determine which policy to fetch based on file type
  let policy: S3PolicyType;

  if (type.startsWith('image/')) {
    policy = await v3ApiService.getS3ImagePolicy(type, name);
  } else if (type.startsWith('video/')) {
    policy = await v3ApiService.getS3VideoPolicy(type, name);
  } else {
    // For all other file types (PDFs, docs, etc.)
    policy = await v3ApiService.getS3FilePolicy(type, name);
  }

  const { S3Policy, S3Signature, CloudFrontLink, Bucket, Key, ContentType, AWSAccessKeyId } =
    policy;

  const formData = new FormData();

  formData.append('key', Key);
  formData.append('Content-Type', ContentType);
  formData.append('AWSAccessKeyId', AWSAccessKeyId);
  formData.append('success_action_status', '201');
  formData.append('policy', S3Policy);
  formData.append('signature', S3Signature);
  formData.append('file', file);
  
  await axios.post(`https://${Bucket}.s3.amazonaws.com/`, formData, {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

      progressCallback?.(percentCompleted);
    },
  });

  return { cloudFrontLink: CloudFrontLink };
};

const S3Service = {
  uploadToBucket,
};

export default S3Service;
